"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = exports.AuthType = void 0;
var AuthType;
(function (AuthType) {
    AuthType["Digest"] = "digest";
    AuthType["None"] = "none";
    AuthType["Password"] = "password";
    AuthType["Token"] = "token";
})(AuthType = exports.AuthType || (exports.AuthType = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["DataTypeNoLength"] = "data-type-no-length";
    ErrorCode["InvalidAuthType"] = "invalid-auth-type";
    ErrorCode["InvalidOutputFormat"] = "invalid-output-format";
    ErrorCode["LinkUnsupportedAuthType"] = "link-unsupported-auth";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
